import React from "react";
import { usePage } from "@brz-utils/contexts/page.context";
import { useSiteSettings } from "@brz-utils/use.site.settings";



export const BreadcrumbsSchema = () => {
    const { page, template } = usePage();
    const { baseUrl } = useSiteSettings();    

    if (!page.sitemap?.breadcrumbs?.length) return null;

    const jsonObj = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": page.sitemap.breadcrumbs.map((item, index) => {
            return {
                "@type": "ListItem",
                "position": index + 1,
                "item": {
                    "@id": createBreadcrumbURL(item.link, baseUrl),
                    "name": item.label,
                }
            };
        })
    };

    function createBreadcrumbURL(path: String, base:String): String {
        /*             
         * Remove the slash at the begining of the path if exists,
         * than add it with base_url to make sure the complete URL is correct if the slash was omitted in the breadcrumb settings
        */
        const _path = path.replace(/^\/+/, '');
        //adding slash here ↴
        return      `${base}/${_path}`;
    }

    return (
        <script id="how-to-schema" type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonObj, null, '  ') }} />
    );
};